export const ENABLE_TRENDING_CITIES = false;
